import { LexicalEditor } from 'lexical';
import { useRef } from 'react';
import { streamDescriptionContainer } from '@/components/streams/stream-banner/banner-description.css.ts';
import { TextEditor } from '@/components/text-editor/text-editor';

export const BannerDescription = ({
  descriptionJson,
  withShowMore = true,
}: {
  descriptionJson?: string | null;
  withShowMore?: boolean;
}) => {
  const descMaxSymbols = 450;

  const ref = useRef<LexicalEditor>(null);

  return (
    <div className={streamDescriptionContainer}>
      <TextEditor
        key={descriptionJson}
        namespace={'banner-description'}
        initialState={descriptionJson}
        editable={false}
        withShowMore={withShowMore}
        charLimit={withShowMore ? descMaxSymbols : undefined}
        theme="small"
        editorRef={ref}
      />
    </div>
  );
};
